import React, { useState } from 'react';
import { Modal, Button, Spinner, Alert } from 'react-bootstrap';
import InbursaUsersCrudService from '../../../services/InbursaUsersCrudService';

const ModalAdvisorStatus = ({ show, handleClose, advisorData, setRenderRows }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleUpdateStatus = async (status) => {
        if (!advisorData) return;

        setIsLoading(true);
        setError(null);


        try {
            console.log(advisorData.code, { enabled: status });
            await InbursaUsersCrudService.setActiveAdvisor(advisorData.code, { enabled: status });
            setRenderRows(); // Refresh the table
            handleClose();
        } catch (err) {
            console.error(err);
            setError("Error updating status. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal show={show} onHide={handleClose} centered backdrop="static" keyboard={true}>
            <Modal.Header closeButton>
                <Modal.Title>¿Qué desea hacer con este asesor?</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Asesor: <strong>{advisorData?.name || advisorData?.email || 'Seleccionado'}</strong></p>
                {error && <Alert variant="danger">{error}</Alert>}
                <div className="d-flex justify-content-center gap-3 mt-4">
                    <Button
                        variant="success"
                        size="lg"
                        onClick={() => handleUpdateStatus(true)}
                        disabled={isLoading}
                    >
                        {isLoading ? <Spinner size="sm" animation="border" /> : "Activar"}
                    </Button>
                    <Button
                        variant="danger"
                        size="lg"
                        onClick={() => handleUpdateStatus(false)}
                        disabled={isLoading}
                    >
                        {isLoading ? <Spinner size="sm" animation="border" /> : "Desactivar"}
                    </Button>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose} disabled={isLoading}>
                    Cancelar / Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalAdvisorStatus;
